/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { GuidedViewMenuLeafNode } from './GuidedViewMenuLeafNode'
import {
  GuidedViewMenuLeafNodeFromJSON,
  GuidedViewMenuLeafNodeFromJSONTyped,
  GuidedViewMenuLeafNodeToJSON,
} from './GuidedViewMenuLeafNode'
import type { GuidedViewMenuResultMenuTree } from './GuidedViewMenuResultMenuTree'
import {
  GuidedViewMenuResultMenuTreeFromJSON,
  GuidedViewMenuResultMenuTreeFromJSONTyped,
  GuidedViewMenuResultMenuTreeToJSON,
} from './GuidedViewMenuResultMenuTree'

/**
 *
 * @export
 * @interface GuidedViewMenuResult
 */
export interface GuidedViewMenuResult {
  /**
   *
   * @type {GuidedViewMenuResultMenuTree}
   * @memberof GuidedViewMenuResult
   */
  menuTree: GuidedViewMenuResultMenuTree
  /**
   *
   * @type {GuidedViewMenuLeafNode}
   * @memberof GuidedViewMenuResult
   */
  selectedMotorNode?: GuidedViewMenuLeafNode | null
  /**
   *
   * @type {GuidedViewMenuLeafNode}
   * @memberof GuidedViewMenuResult
   */
  selectedCabColorNode?: GuidedViewMenuLeafNode | null
  /**
   *
   * @type {GuidedViewMenuLeafNode}
   * @memberof GuidedViewMenuResult
   */
  selectedChassiColorNode?: GuidedViewMenuLeafNode | null
  /**
   *
   * @type {string}
   * @memberof GuidedViewMenuResult
   */
  interiorMenuIdAllView?: string | null
}

/**
 * Check if a given object implements the GuidedViewMenuResult interface.
 */
export function instanceOfGuidedViewMenuResult(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'menuTree' in value

  return isInstance
}

export function GuidedViewMenuResultFromJSON(json: any): GuidedViewMenuResult {
  return GuidedViewMenuResultFromJSONTyped(json, false)
}

export function GuidedViewMenuResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GuidedViewMenuResult {
  if (json === undefined || json === null) {
    return json
  }
  return {
    menuTree: GuidedViewMenuResultMenuTreeFromJSON(json['menuTree']),
    selectedMotorNode: !exists(json, 'selectedMotorNode')
      ? undefined
      : GuidedViewMenuLeafNodeFromJSON(json['selectedMotorNode']),
    selectedCabColorNode: !exists(json, 'selectedCabColorNode')
      ? undefined
      : GuidedViewMenuLeafNodeFromJSON(json['selectedCabColorNode']),
    selectedChassiColorNode: !exists(json, 'selectedChassiColorNode')
      ? undefined
      : GuidedViewMenuLeafNodeFromJSON(json['selectedChassiColorNode']),
    interiorMenuIdAllView: !exists(json, 'interiorMenuIdAllView')
      ? undefined
      : json['interiorMenuIdAllView'],
  }
}

export function GuidedViewMenuResultToJSON(
  value?: GuidedViewMenuResult | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    menuTree: GuidedViewMenuResultMenuTreeToJSON(value.menuTree),
    selectedMotorNode: GuidedViewMenuLeafNodeToJSON(value.selectedMotorNode),
    selectedCabColorNode: GuidedViewMenuLeafNodeToJSON(
      value.selectedCabColorNode,
    ),
    selectedChassiColorNode: GuidedViewMenuLeafNodeToJSON(
      value.selectedChassiColorNode,
    ),
    interiorMenuIdAllView: value.interiorMenuIdAllView,
  }
}
